var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDevices = function SvgDevices(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EAE9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3941 11.1912C21.2685 13.0065 21.2685 15.9496 19.3941 17.7649M12.606 17.7649C10.7315 15.9496 10.7315 13.0065 12.606 11.1912M10.3431 19.9562C7.21897 16.9307 7.21897 12.0255 10.3431 9M21.6569 9C24.781 12.0255 24.781 16.9307 21.6569 19.9562M16 16.0275C16.8836 16.0275 17.6 15.3338 17.6 14.4781C17.6 13.6223 16.8836 12.9286 16 12.9286C15.1164 12.9286 14.4 13.6223 14.4 14.4781C14.4 15.3338 15.1164 16.0275 16 16.0275ZM16 16.0275V23",
    stroke: "#696593",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C17.1046 16 18 15.3284 18 14.5C18 13.6716 17.1046 13 16 13C14.8954 13 14 13.6716 14 14.5C14 15.3284 14.8954 16 16 16Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDevices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Devices.490ee3ddaf5bf9b802a79bcf278509e6.svg";